import { convertToGithubLayout } from './utils/veloUtils.js';
const initVeloCodeUpdate = () => {
    return {
        layout: 'GITHUB',
        ignoreForbiddenPaths: true
    };
};
export const applyDeleteCode = (codeUpdate, path) => {
    if (!codeUpdate) {
        codeUpdate = initVeloCodeUpdate();
    }
    codeUpdate.pathsToDelete ??= [];
    codeUpdate.pathsToDelete.push(path);
    return codeUpdate;
};
export const applyUpdateCode = (codeUpdate, veloFile) => {
    if (!codeUpdate) {
        codeUpdate = initVeloCodeUpdate();
    }
    codeUpdate.filesToUpdate ??= [];
    codeUpdate.filesToUpdate.push(veloFile);
    return codeUpdate;
};
export const accumulateFsUpdateToVeloCodeUpdate = async (state, veloCodeUpdate, structureInfo, { path, action }) => {
    let result = veloCodeUpdate;
    const pathInGithubLayout = convertToGithubLayout(state, path, structureInfo.folderType);
    if (action === 'DELETE') {
        result = applyDeleteCode(result, pathInGithubLayout);
    }
    else if (action === 'UPDATE') {
        result = applyUpdateCode(result, {
            path: pathInGithubLayout,
            content: await state.fileSystem.readFile(path)
        });
    }
    return result;
};
